module.exports = __webpack_public_path__ + "./assets/opcity_logo.png";